import { useSelector } from 'react-redux';
import { ApplicationState as State } from '../../../store';

export const useTablet = (): boolean => useSelector((state: State) => state?.browser?.lessThan?.md);
